<!-- START OF SLIDER SECTION -->
<!-- <div class="wrapper">
  <input class="slider-input" checked type="radio" name="slider" id="slide1" />
  <input class="slider-input" type="radio" name="slider" id="slide2" />
  <input class="slider-input" type="radio" name="slider" id="slide3" />

  <div class="slider-wrapper">
    <div class="inner">
      <article>
        <img src="/assets/img/resources/home/brokerage_banner.jpg" />
      </article>

      <article>
        <img src="/assets/img/resources/home/logo_tracking_banner.jpg" />
      </article>

      <article>
        <img src="/assets/img/resources/home/logo_remit_banner.png" />
      </article>
    </div>
  </div>

  <div class="slider-prev-next-control">
    <label for="slide1"></label>
    <label for="slide2"></label>
    <label for="slide3"></label>
  </div>

  <div class="slider-dot-control">
    <label for="slide1"></label>
    <label for="slide2"></label>
    <label for="slide3"></label>
  </div>
</div> -->

<app-carousel></app-carousel>

<!-- END OF SLIDER SECTION -->

<!-- START ABOUT US -->
<div class="section py-5 bg-light">
  <div class="container">
    <div class="row align-items-center">
      <!-- Video Side -->
      <div class="col-lg-6 mb-4 mb-lg-0">
        <video
          class="img-fluid rounded shadow"
          controls
          autoplay
          muted
          src="/assets/videos/home/about.mp4"
          style="width: 100%; height: auto"
        ></video>
      </div>

      <!-- Content Side -->
      <div class="col-lg-6">
        <h2 class="fw-bold display-5 text-success section-title">ABOUT</h2>
        <p>
          Founded in 2001 by Joel P. Longares as a humble money remittance
          company, LOGO has since grown into a trusted name in balikbayan box
          shipping and global logistics. What began as a service for overseas
          Filipinos has now evolved into a multi-branch operation with 26
          locations across Northern California, Nevada, Chicago, Washington, and
          Hawaii — and a thriving presence in Canada, with branches in
          Mississauga, Edmonton, Calgary, Scarborough, and Winnipeg.
        </p>
        <p>
          LOGO has also extended its reach beyond North America, proudly
          offering balikbayan box services to Dubai, Norway, Denmark, and the
          United Kingdom, solidifying our footprint on the global map.
        </p>
        <p>
          In 2023, LOGO embraced a bold new chapter. Fueled by a renewed vision
          for excellence and inspired by our founder's legacy, LOGO began its
          transformation into a world-class logistics brand—committed not just
          to service, but to the Longares name, built on trust, resilience, and
          Filipino pride.
        </p>
        <p>
          Today, LOGO proudly stands as a leading provider of balikbayan box and
          money remittance services in the U.S. and Canada, while also offering
          innovative solutions like <strong>LOGO Megastore</strong> and
          <strong>LOGO Driver Express</strong>, tailored to meet the diverse and
          growing needs of our customers.
        </p>
      </div>
    </div>

    <hr class="my-5" />

    <!-- Why Choose LOGO -->
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="col-12">
          <h2 class="fw-bold display-5 text-success section-title">
            WHY CHOOSE LOGO?
          </h2>
        </div>

        <div class="col-md-12 mb-4">
          <div class="p-4 bg-white shadow-sm rounded h-100">
            <h4 class="fw-semibold mb-3">1. Quality Control You Can Trust</h4>
            <p>
              At LOGO, we uphold a rigorous quality control system that ensures
              every parcel is handled with care, every transaction is secure,
              and every customer is assured peace of mind. From pick-up to
              delivery, we deliver reliability, accountability, and
              excellence—every step of the way.
            </p>
          </div>
        </div>

        <div class="col-md-12 mb-4">
          <div class="p-4 bg-white shadow-sm rounded h-100">
            <h4 class="fw-semibold mb-3">2. Highly Professional Team</h4>
            <p>
              Our people are our strength. LOGO invests in extensive training
              and development programs for our staff, empowering them to provide
              personalized, customer-first service grounded in efficiency,
              empathy, and professionalism. It&apos;s more than just
              service—it&apos;s the Longares standard.
            </p>
          </div>
        </div>
      </div>

      <div class="col-lg-6 mb-4 mb-lg-0">
        <img
          src="/assets/img/resources/it_team_new.jpg"
          alt="About LOGO"
          class="img-fluid rounded shadow"
        />
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <p class="lead fst-italic text-center">
            At LOGO, we don&apos;t just move boxes, we move lives forward.
            Whether you&apos;re sending love to family or starting a business
            across borders, we&apos;re here to deliver with heart, heritage, and
            honor.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- END OF ABOUT US  -->

<!-- SHIP OF BALIKBAYAN BOX -->
<div class="section py-5 bg-white">
  <div class="container">
    <div class="row">
      <!-- Balikbayan Box Service -->
      <div class="col-lg-6">
        <div class="card border-0 shadow-sm h-100">
          <img
            src="/assets/img/resources/home/ship-a-balikbayan-box.png"
            class="card-img-top"
            alt="Balikbayan Box"
          />
          <div class="card-body">
            <h2 class="card-title fw-bold text-danger mb-3">
              Ship a Balikbayan Box
            </h2>
            <ul class="list-unstyled mb-4">
              <li class="mb-2">
                <i class="bi bi-check-circle-fill text-success me-2"></i>Send
                from the United States of America and Canada
              </li>
              <li class="mb-2">
                <i class="bi bi-check-circle-fill text-success me-2"></i
                >Door-to-door delivery
              </li>
              <li class="mb-2">
                <i class="bi bi-check-circle-fill text-success me-2"></i
                >Affordable box sizes
              </li>
            </ul>
            <a href="#" class="text-decoration-none fw-medium text-dark">
              Learn more <i class="bi bi-arrow-right-circle-fill ms-1"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Money Remittance Service -->
      <div class="col-lg-6">
        <div class="card border-0 shadow-sm h-100">
          <img
            src="/assets/img/resources/home/ship-money-to-the philippines.png"
            class="card-img-top"
            alt="Remit Money"
          />
          <div class="card-body">
            <h2 class="card-title fw-bold text-danger mb-3">
              Send Money to the Philippines
            </h2>
            <ul class="list-unstyled mb-4">
              <li class="mb-2">
                <i class="bi bi-check-circle-fill text-success me-2"></i>Fast &
                secure transaction
              </li>
              <li class="mb-2">
                <i class="bi bi-check-circle-fill text-success me-2"></i
                >Thousands of payout locations
              </li>
              <li class="mb-2">
                <i class="bi bi-check-circle-fill text-success me-2"></i>Powered
                by Uniteller
              </li>
            </ul>
            <a href="#" class="text-decoration-none fw-medium text-dark">
              Learn more <i class="bi bi-arrow-right-circle-fill ms-1"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- END SHIP OF BALIKBAYAN BOX -->

<!-- START OF TRACKING BOX -->
<div class="section py-5 bg-light">
  <div class="container text-center">
    <h1 class="fw-bold display-5 text-success section-title">TRACK YOUR BOX</h1>
    <p class="mb-4 text-muted">
      Enter your tracking number below to check your shipment status.
    </p>

    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 mx-auto">
        <form>
          <div class="input-group input-group-lg shadow-sm">
            <input
              type="text"
              class="form-control"
              name="tracking_number"
              id="invoiceno"
              placeholder="Enter Tracking Number"
              [formControl]="invoiceFormControl"
            />
            <!-- <button class="btn btn-primary" type="submit" (click)="openModal()"> -->
            <button class="btn btn-primary" (click)="redirectTrackingPage()">
              TRACK
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- END OF TRACKING BOX -->

<!-- START DOWNLOAD APP SECTION -->
<div class="star-download text-white">
  <div class="container py-5 d-flex justify-content-center">
    <div class="inner-image-wrapper position-relative">
      <div class="inner-image-background"></div>
      <img
        src="/assets/img/resources/logo_tracking(1).jpg"
        alt="App Preview"
        class="img-fluid rounded-2xl inner-app-image"
      />
      <div class="inner-content position-absolute text-white">
        <div class="row">
          <div class="col-md-6">
            <span><p></p></span>
          </div>

          <div class="col-md-6 d-flex flex-column gap-2">
            <div class="row">
              <div>
                <h1 class="fw-bold text-uppercase text-white">
                  Ship Money to<br />the Philippines
                </h1>

                <ul class="list-unstyled mb-0">
                  <li class="mb-3 fs-5">
                    <i class="bi bi-check-circle-fill text-success me-2"></i>
                    30+ Years of Service
                  </li>
                  <li class="mb-3 fs-5">
                    <i class="bi bi-check-circle-fill text-success me-2"></i
                    >60,000+ Satisfied Customers
                  </li>
                  <li class="mb-3 fs-5">
                    <i class="bi bi-check-circle-fill text-success me-2"></i
                    >Door-to-door pick to delivery
                  </li>
                  <li class="mb-3 fs-5">
                    <i class="bi bi-check-circle-fill text-success me-2"></i
                    >More than 25 store branches
                  </li>
                </ul>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <a
                    href="https://apps.apple.com/ph/app/logo-mobile/id1585548899"
                    target="_blank"
                    class="btn p-0 border-0"
                  >
                    <img
                      src="/assets/img/badge/app-store-badge.png"
                      alt="Download on the App Store"
                      class="img-fluid"
                      style="height: 60px"
                    />
                  </a>
                </div>
                <div class="col-lg-6">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.axp.customer&hl=en"
                    target="_blank"
                    class="btn p-0 border-0"
                  >
                    <img
                      src="/assets/img/badge/google-play-badge.png"
                      alt="Get it on Google Play"
                      class="img-fluid"
                      style="height: 60px"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- END DOWNLOAD APP SECTION -->

<div class="container-fluid hero-section py-5">
  <div class="container text-center">
    <div class="mb-3">
      <h1 class="fw-bold display-5 text-success section-title">
        WHY SHIP WITH LOGO
      </h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-6">
        <div class="row g-4">
          <div class="col-md-6" *ngFor="let feature of features; let i = index">
            <div
              class="feature-card h-100"
              [class.feature-hovered]="hoveredFeature === i"
              (mouseenter)="onFeatureHover(i)"
              (mouseleave)="onFeatureLeave()"
            >
              <div class="card border-0 h-100 shadow-sm">
                <div class="card-body p-4">
                  <div class="d-flex align-items-start">
                    <div
                      [class]="'feature-icon ' + feature.colorClass + ' me-3'"
                    >
                      <i [class]="feature.icon"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div class="d-flex align-items-center mb-2">
                        <h6 class="card-title mb-0 me-2">
                          {{ feature.title }}
                        </h6>
                        <i class="bi bi-check-circle-fill text-success"></i>
                      </div>
                      <p class="card-text small mb-0">
                        {{ feature.description }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="feature-overlay"
                  [class]="feature.colorClass + '-overlay'"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-lg-6 d-flex justify-content-center align-items-center mt-4"
      >
        <img src="/assets/img/boxes/download-mobile-app.png" alt="" />
        <!-- <div class="row">
          <div class="col-lg-6">
            <img
              src="/assets/img/badge/download-qr.png"
              class="download-mobile-app"
              alt=""
            />
          </div>

          <div class="col-lg-6">
            <img
              src="/assets/img/badge/download-logo.png"
              class="logo-img mb-3"
              alt="App Logo"
            />
            <div class="mb-2">
              <img
                src="/assets/img/badge/download-app-store.png"
                class="store-btn"
                alt="App Store"
              />
            </div>
            <div>
              <img
                src="/assets/img/badge/download-google-play.png"
                class="store-btn"
                alt="Google Play"
              />
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>

<div class="contact-section">
  <div class="contact-header">
      <h2>Get in Touch</h2>
      <p>Have questions about our balikbayan box or money remittance services?<br>We're here to help!</p>
      
      <a class="toll-free-link" *ngFor="let phone of visiblePhones" [href]="'tel:' + phone.tel" [attr.aria-label]="'Call ' + phone.label + ' ' + phone.display">
        <div class="toll-free-box flex-column">
          <div class="toll-free-label">{{ phone.label }}</div>
          <div class="toll-free-number">{{ phone.display }}</div>
          <!-- <div class="call-icon" aria-hidden="true">📞</div> -->
        </div>
      </a>
      
      <p style="margin-top: 20px; color: #888;">Call us anytime for assistance with your shipping and remittance needs.</p>
  </div>
</div>

<div class="partners container-fluid">
  <div class="row">
    <div class="col-lg-2">
      <a href="https://www.my7107.com/" target="_blank">
        <img src="/assets/img/resources/logos/7107-islands.png" alt="7107 Islands" />
      </a>
    </div>

    <div class="col-lg-2">
      <a href="https://www.abxpinc.com/" target="_blank">
        <img src="/assets/img/resources/logos/abxp.png" alt="ABXP" />
      </a>
    </div>

    <div class="col-lg-2">
      <a href="https://www.abxpinc.com/" target="_blank">
        <img src="/assets/img/resources/logos/jolong-enterprise.png" alt="Jolong Enterprise" />
      </a>
    </div>

    <div class="col-lg-2">
      <a href="https://us.logocargo.com/" target="_blank">
        <img src="/assets/img/resources/logos/logo-inc.png" alt="Logo Inc" />
      </a>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-2">
      <a href="https://mylogoinc.com" target="_blank">
        <img src="/assets/img/resources/logos/logo-inc-bpo.png" alt="Logo Inc BPO" />
      </a>
    </div>

    <div class="col-lg-2">
      <a href="https://ca.logocargo.com/" target="_blank">
        <img src="/assets/img/resources/logos/logo-ulc.png" alt="ULC" />
      </a>
    </div>

    <div class="col-lg-4">
      <a href="https://logoremit.com/" target="_blank">
        <img
          src="/assets/img/resources/logos/axpremit-uniteller-2024.png"
          alt="AXP Remit Uniteller"
        />
      </a>
    </div>
  </div>
</div>

<!-- Tracking Modal -->
<!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-hidden="true">
  <div
    class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title">ABCD13456</h1>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">This is inside modal.</div>
    </div>
  </div>
</div> -->
